<template>
  <v-card>
    <v-card-title>
      <v-row align="center" class="search-field">
        <v-col md="6">
          <text-field
            class="mb-5"
            v-model="filters.searchStr"
            append-icon="mdi-filter"
            label="Filter"
            single-line
            hide-details></text-field>
        </v-col>
      </v-row>
    </v-card-title>
    <v-data-table
      :items="docks"
      :headers="headers"
      :search="filters.searchStr"
      :item-class="getSelectedClass"
      class="dock-select-table"
      :footer-props="footerProps"
      :options.sync="options">
      <template v-slot:[`item.name`]="{ item }">
        <v-tooltip v-if="item.name" top>
          <template v-slot:activator="{ on }">
            <span v-on="on">{{ novaCore.truncateString(item.name, 50) }}</span>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <primary-button @click="handleClick(item)" x-small>
          Select
          <v-icon x-small>mdi-arrow-right</v-icon>
        </primary-button>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import dataListMixin from '@satellite/components/mixins/dataListMixin';

export default {
  mixins: [dataListMixin],
  props: {
    /**
     * @model
     */
    value: {
      required: true
    },
    docks: {
      type: Array,
      required: true
    }
  },
  filters: {
    highlight(value, query) {
      if (typeof value !== 'string') {
        return value;
      }

      return query
        ? value.replace(new RegExp(query, 'ig'), v => `<span class="orange lighten-3">${v}</span>`)
        : value;
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'Name',
          value: 'name',
          searchable: true,
          sortable: true
        },
        {
          text: 'Door Number',
          value: 'doorNumber',
          searchable: true,
          sortable: true
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          align: 'end'
        }
      ],
      selectedDock: null,
      sortBy: ['name', 'asc'],
      totalDocks: 0
    };
  },
  methods: {
    /**
     * Fetch load types based on selected warehouse
     * @public
     * @returns {Promise<void>}
     */
    handleClick(dock) {
      this.selectedDock = dock;
      this.$emit('input', dock);
      this.$emit('selected');
    },
    getSelectedClass(item) {
      let selectedClass = 'dock-select-item';
      if (item.id === this.selectedLoadType?.id) {
        selectedClass += ' is-selected';
      }
      return selectedClass;
    }
  },
  mounted() {}
};
</script>
